var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGouzhuwu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 592",
    d: "M5.80944 1.94458H1.35693V14.1266H14.7501V1.94458H10.0838V5.57783H5.80944V1.94458Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 591",
    d: "M5.84499 12.2744V1.87335H1.25V14.1267H14.75V1.87335H10.0125V12.2744",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 15",
    x1: 3.38843,
    y1: 5.25595,
    x2: 12.614,
    y2: 5.25595,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 16",
    x1: 3.38843,
    y1: 9.03168,
    x2: 12.614,
    y2: 9.03168,
    stroke: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGouzhuwu);
export default __webpack_public_path__ + "static/media/gouzhuwu.0bd49c3ecbb11c4999433ba262a17500.svg";
export { ForwardRef as ReactComponent };